import React from 'react';
import Lightbox from 'react-awesome-lightbox';
import Countdown from 'react-countdown';
import {
  Search,
  ChevronDown,
  ChevronUp,
  Grid3X3,
  List,
  Clock,
  Users,
  CalendarDays,
} from 'lucide-react';
import i18n from '../../../../i18n';
import { getGroupedAuctions } from '../../../../models/auctions';
import { AuctionListGrouped } from '../../../helpers/skeletons/AuctionListGrouped';
import { getCategories } from '../../../../models/categories';
import { getOrganizations } from '../../../../models/organization';
import { CustomEnroll } from '../../../helpers/customEnroll';
import AuctionListCard from '../Auctions/components/AuctionListCard';
import AuctionCardNew from '../../components/Auction/AuctionCard';
import '../../../../styles/components/auctions-page.scss';
import '../../../../styles/components/auction-list-card.scss';
import { NavLink } from 'react-router-dom';
import { getLoggedUser } from '../../../../state/user';

const user = getLoggedUser();

const FinishBid = () => <span className="text-danger">{i18n.t('time_ends')}</span>;
const renderer = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) {
    return <FinishBid />;
  } else {
    let warning = days === 0 && hours === 0 && minutes === 0 && seconds < 10 ? true : false;
    return (
      <span
        className={
          warning ? 'text-danger countdown-listing-pg countdwn-warning' : 'countdown-listing-pg'
        }
      >
        {days}
        {i18n.t('D')} : {hours}
        {i18n.t('H')} : {minutes}
        {i18n.t('M')} : {seconds}
        {i18n.t('S')}
      </span>
    );
  }
};

let is_logged = localStorage.getItem('is_logged_in') ? true : false;
let lng = localStorage.getItem('I18N_LANGUAGE');
let group_limit = localStorage.getItem('group_limit');

export class AuctionsListGrouped extends React.Component {
  constructor() {
    super();
    let path = window.location.pathname;
    let groupID = path.substring(path.lastIndexOf('/') + 1, path.length);

    let urlParams = new URLSearchParams(window.location.search);
    let param1Value = urlParams.get('type');
    let isMobile = window.innerWidth <= 768;

    this.state = {
      section: 'main',
      catArrs: [],
      page_type: param1Value,
      categories: [],
      input: {
        auction: '',
      },
      organizations: [],
      auctions: {},
      limit: 30,
      meta: {},
      loading: false,
      group: groupID,
      gpData: {},
      orgData: {},
      enrolledUsers: 0,
      lightboxImages: [],
      is_active_light_box: false,
      grid: isMobile,
      openSections: { category: true },
      now: () => {
        return new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Muscat' }));
      },
    };
    this.handleChange = this.handleChange.bind(this);
    this.loadGroupedAuctions = this.loadGroupedAuctions.bind(this);
    this.getImagePopup = this.getImagePopup.bind(this);
    this.searchAuctions = this.searchAuctions.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    let urlSearchParams = new URLSearchParams(window.location.search);
    let params = Object.fromEntries(urlSearchParams.entries());
    let lt = group_limit || 30;
    this.loadGroupedAuctions(lt);
    this.loadAllCategories(params);
    this.loadAllOrganizations(params);
    this.handleResize = () => {
      this.setState({ grid: window.innerWidth <= 768 });
    };
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  async loadAllOrganizations(params) {
    this.setState({ is_org_loading: true });
    if (typeof params.organization !== 'undefined') {
      var org = params.organization;
      this.setState({ orgArrs: [parseInt(org)] });
    }
    const response = await getOrganizations();
    if (response) {
      let organizations = response.data;
      this.setState({ organizations });
      this.setState({ is_org_loading: false });
    }
  }

  async loadAllCategories(params) {
    this.setState({ is_cat_loading: true });
    if (typeof params.category !== 'undefined') {
      var category = params.category;
      this.setState({ catArrs: [parseInt(category)] });
    }
    const response = await getCategories();
    if (response) {
      let categories = response.data;
      this.setState({ categories });
      this.setState({ is_cat_loading: false });
    }
  }

  createCategory(id, sub = false) {
    if (sub) {
      var subCatArrs = this.state.catArrs;
      if (subCatArrs.includes(id)) {
        const index = subCatArrs.indexOf(parseInt(id));
        if (index > -1) {
          subCatArrs.splice(index, 1);
        }
      } else {
        subCatArrs.push(parseInt(id));
      }
      this.setState({ subCatArrs: subCatArrs });
      this.applyFilters();
    } else {
      if (!id) {
        this.setState({ catArrs: [] });
        this.applyFilters();
        return;
      }
      var catArrs = this.state.catArrs;
      if (catArrs.includes(id)) {
        const index = catArrs.indexOf(parseInt(id));
        if (index > -1) {
          catArrs.splice(index, 1);
        }
      } else {
        catArrs.push(parseInt(id));
      }
      this.setState({ catArrs: catArrs });
      this.applyFilters();
    }
  }

  applyFilters() {
    var type = this.state.type;
    var section = this.state.section;
    var catArrs = this.state.catArrs;
    var cats = catArrs.join(',');
    if (catArrs.length < 1) {
      cats = '';
    }
    this.setState({
      category: cats,
      type: type,
      section: section,
    });
    this.loadGroupedAuctions({
      sec: section,
      type: type,
      category: cats,
    });
  }

  handleChange(event) {
    let input = this.state.input;
    input[event.target.name] = event.target.value;
    this.setState({ input });
  }

  async loadGroupedAuctions(params) {
    localStorage.setItem('group_limit', params.limit);
    this.setState({ limit: params.limit });
    let { group } = this.state;
    let q = '';
    if (group) {
      q += 'group=' + group;
    }
    if (!isNaN(params.limit)) {
      q += '&limit=' + params.limit;
    }
    if (typeof params.category !== 'undefined') {
      q += '&category=' + params.category;
    }
    this.setState({ loading: true });
    const response = await getGroupedAuctions(q);
    let auctions = response.data;
    let meta = response.meta;
    if (auctions) {
      this.setState({ auctions: auctions, meta, loading: false });
    }
    if (meta.group) {
      this.setState({ gpData: meta.group });
    }
    if (meta.organization) {
      this.setState({ orgData: meta.organization });
    }
    if (meta.enrolledUsers) {
      this.setState({ enrolledUsers: meta.enrolledUsers });
    }
  }

  async searchAuctions() {
    let { group } = this.state;
    let q = '';
    if (group) {
      q += 'group=' + group;
    }
    if (this.state.input.auction) {
      q += '&auction=' + this.state.input.auction;
    }
    q += '&lang=' + lng;
    this.setState({ loading: true });
    const response = await getGroupedAuctions(q);
    let auctions = response.data;
    let meta = response.meta;
    if (auctions) {
      this.setState({ auctions: auctions, meta, loading: false });
    }
    if (meta.group) {
      this.setState({ gpData: meta.group });
    }
    if (meta.organization) {
      this.setState({ orgData: meta.organization });
    }
    if (meta.enrolledUsers) {
      this.setState({ enrolledUsers: meta.enrolledUsers });
    }
  }

  createDate(dt) {
    return dt ? new Date(dt.replace(/-/g, '/')) : null;
  }

  getImagePopup(active, images) {
    let lightboxImages = [];
    if (images) {
      images.forEach(function (arrayItem) {
        lightboxImages.push({
          url: arrayItem.image,
        });
      });
      this.setState({
        is_active_light_box: active,
        lightboxImages: lightboxImages,
      });
    }
  }

  sortByOrder(data) {
    let result = data;
    if (data.length) {
      result = data.sort((a, b) => a.order - b.order);
    }
    return result;
  }

  toggleSection = (key) => {
    this.setState((prev) => ({
      openSections: { ...prev.openSections, [key]: !prev.openSections[key] },
    }));
  };

  render() {
    let { categories, auctions, catArrs, gpData, now, openSections } = this.state;
    let can_show_custom_enroll = false;
    let groupRegEndDate = new Date(this.createDate(gpData.reg_end_date));

    if (
      gpData.is_auctions_grouped &&
      !gpData.is_grouped_enroll &&
      is_logged &&
      groupRegEndDate > now()
    ) {
      can_show_custom_enroll = true;
    }
    auctions = this.sortByOrder(auctions);
    let total_auctions = this.state.meta.total;
    let endDate = this.state.gpData.reg_end_date;
    let endTime = endDate ? new Date(endDate.replace(/-/g, '/')).getTime() : 0;
    let visit_amount = Number(this.state.gpData.visit_amount);
    let current_lng = localStorage.getItem('I18N_LANGUAGE');

    const grid = this.state.grid;

    return (
      <React.Fragment>
        {this.state.loading && (
          <div className="container" id="auction-grouped">
            <AuctionListGrouped />
          </div>
        )}

        {!this.state.loading && (
          <div className="mza-page">
            {/* ══════════ REGISTRATION INFO BAR ══════════ */}
            <div className="mza-reg-bar">
              <div className="mza-reg-bar__inner">
                <div className="mza-reg-bar__item">
                  <Clock size={16} className="mza-reg-bar__icon" />
                  <span className="mza-reg-bar__label">{i18n.t('reg_start')}</span>
                  <span className="mza-reg-bar__value">{gpData.reg_start_date_formatted}</span>
                </div>
                <div className="mza-reg-bar__divider" />
                <div className="mza-reg-bar__item">
                  <CalendarDays size={16} className="mza-reg-bar__icon" />
                  <span className="mza-reg-bar__label">{i18n.t('reg_end')}</span>
                  <span className="mza-reg-bar__value">
                    {endDate && <Countdown date={endTime} renderer={renderer} now={now} />}
                  </span>
                </div>
                <div className="mza-reg-bar__divider" />

                {['A', 'F', 'PM', 'OM', 'GE', 'CE', 'GM'].includes(user?.role) ? (
                  this.state.enrolledUsers > 0 ? (
                    <NavLink
                      to={`/enrollments/list?status=approved&group=${this.state.group}`}
                      className="mza-reg-bar__item"
                    >
                      <Users size={16} className="mza-reg-bar__icon" />
                      <span className="mza-reg-bar__label">{i18n.t('enrolled_users')}</span>
                      <span className="mza-reg-bar__value">{this.state.enrolledUsers}</span>
                    </NavLink>
                  ) : (
                    <NavLink
                      to={`/enrollments/list?page=1&limit=15&group=${this.state.group}&status=pending_mzadcom`}
                      className="mza-reg-bar__item"
                    >
                      <Users size={16} className="mza-reg-bar__icon" />
                      <span className="mza-reg-bar__label">{i18n.t('enrolled_users')}</span>
                      <span className="mza-reg-bar__value">{this.state.enrolledUsers}</span>
                    </NavLink>
                  )
                ) : (
                  <div className="mza-reg-bar__item">
                    <Users size={16} className="mza-reg-bar__icon" />
                    <span className="mza-reg-bar__label">{i18n.t('enrolled_users')}</span>
                    <span className="mza-reg-bar__value">{this.state.enrolledUsers}</span>
                  </div>
                )}
              </div>
            </div>

            <div className="bidd_hidden_sm">
              <div className="mza-results-header">
                <div className="mza-results-header__inner">
                  <div className="mza-search-bar">
                    <Search size={18} className="mza-search-bar__icon" />
                    <input
                      type="text"
                      name="auction"
                      className="mza-search-bar__input"
                      placeholder={i18n.t('search') || 'Search'}
                      value={this.state.input.auction}
                      onChange={this.handleChange}
                      onKeyDown={(e) => e.key === 'Enter' && this.searchAuctions()}
                    />
                  </div>
                  <button className="mza-search-bar__btn" onClick={this.searchAuctions}>
                    {i18n.t('search') || 'Search'}
                  </button>

                  <span className="mza-results-header__count">
                    {total_auctions || 0} {i18n.t('auctions') || 'auctions'}
                  </span>

                  <div className="mza-results-header__actions">
                    <div className="mza-view-toggle">
                      <button
                        className={`mza-view-toggle__btn ${grid ? 'mza-view-toggle__btn--active' : ''}`}
                        onClick={() => this.setState({ grid: true })}
                      >
                        <Grid3X3 size={16} />
                      </button>
                      <button
                        className={`mza-view-toggle__btn ${!grid ? 'mza-view-toggle__btn--active' : ''}`}
                        onClick={() => this.setState({ grid: false })}
                      >
                        <List size={16} />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ══════════ MAIN: Sidebar + Grid ══════════ */}
            <div className="mza-main">
              <div className="mza-main__inner">
                {/* ── Sidebar ── */}
                <aside className="mza-sidebar">
                  <div className="mza-sidebar__header">
                    <h3 className="mza-sidebar__title">
                      {i18n.t('filter_results') || 'Filter Results'}
                    </h3>
                  </div>

                  {/* Custom Enroll */}
                  {can_show_custom_enroll && (
                    <div style={{ marginBottom: 16 }}>
                      <CustomEnroll group={gpData.id} />
                    </div>
                  )}

                  {/* Category filter */}
                  <div className="mza-filter-group">
                    <button
                      className="mza-filter-group__header"
                      onClick={() => this.toggleSection('category')}
                    >
                      <span>{i18n.t('category') || 'Category'}</span>
                      {openSections.category ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                    </button>
                    {openSections.category && (
                      <div className="mza-filter-group__body">
                        <label className="mza-radio">
                          <input
                            type="radio"
                            name="cat"
                            checked={catArrs.length === 0}
                            onChange={() => this.createCategory(false)}
                          />
                          <span className="mza-radio__mark" />
                          <span className="mza-radio__label">{i18n.t('all') || 'All'}</span>
                        </label>
                        {categories.map((cat) => (
                          <label key={cat.id} className="mza-checkbox">
                            <input
                              type="checkbox"
                              checked={catArrs.includes(cat.id)}
                              onChange={() => this.createCategory(cat.id)}
                            />
                            <span className="mza-checkbox__mark" />
                            <span className="mza-checkbox__label">
                              {current_lng === 'ar' ? cat.category_name_ar : cat.category_name}
                            </span>
                          </label>
                        ))}
                      </div>
                    )}
                  </div>
                </aside>

                {/* ── Grid Area ── */}
                <div className="mza-grid-area">
                  {auctions.length < 1 && (
                    <div className="mza-empty">
                      <Search size={48} />
                      <p>{i18n.t('no_auctions_found')}</p>
                    </div>
                  )}

                  {/* Grid view */}
                  {grid && auctions.length > 0 && (
                    <div className="mza-card-grid">
                      {auctions.map((item, i) => {
                        return (
                          <div key={item.id || i} className="mza-card-grid__item">
                            <AuctionCardNew
                              auction={item}
                              auctionId={item.id}
                              screen="groupList"
                              visit_amount={visit_amount}
                              group={this.state.gpData}
                              type={this.state.page_type}
                            />
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {/* List view */}
                  {!grid && auctions.length > 0 && (
                    <div className="mza-list-view">
                      {auctions.map((item, i) => {
                        let key = parseInt(i) + 1;
                        return (
                          <AuctionListCard
                            key={item.id || i}
                            auction={item}
                            keys={key}
                            getImagePopup={this.getImagePopup}
                            screen="groupList"
                            visit_amount={visit_amount}
                            group={this.state.gpData}
                            type={this.state.page_type}
                          />
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {this.state.is_active_light_box && (
          <Lightbox
            images={this.state.lightboxImages}
            onClose={() => {
              this.setState({ is_active_light_box: false });
            }}
          />
        )}
      </React.Fragment>
    );
  }
}
